/**
 * Notification preference types for academy owner settings.
 * Per notification type, per channel (email, in-app, push) toggles.
 */

export type NotificationPreferenceKey =
  | 'absence_reported'
  | 'makeup_lesson_picked'
  | 'low_enrolment'
  | 'refund_requested'
  | 'payment_failed'
  | 'new_booking_requested'
  | 'new_booking_confirmed'
  | 'eoi_submitted';

export interface ChannelPreferences {
  email: boolean;
  inApp: boolean;
  push: boolean;
}

export type NotificationPreferences = Record<NotificationPreferenceKey, ChannelPreferences>;

const DEFAULT_CHANNEL: ChannelPreferences = {
  email: true,
  inApp: true,
  push: false,
};

const PREFERENCE_KEYS: NotificationPreferenceKey[] = [
  'absence_reported',
  'makeup_lesson_picked',
  'low_enrolment',
  'refund_requested',
  'payment_failed',
  'new_booking_requested',
  'new_booking_confirmed',
  'eoi_submitted',
];

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = Object.fromEntries(
  PREFERENCE_KEYS.map((key) => [key, { ...DEFAULT_CHANNEL }])
) as NotificationPreferences;

export const NOTIFICATION_PREFERENCE_LABELS: Record<NotificationPreferenceKey, string> = {
  absence_reported: 'Student reports absence',
  makeup_lesson_picked: 'Student picks a make-up lesson',
  low_enrolment: 'Low enrolment alert',
  refund_requested: 'Refund request received',
  payment_failed: 'Payment failure',
  new_booking_requested: 'New booking requested to confirm',
  new_booking_confirmed: 'New booking confirmed',
  eoi_submitted: 'Expression of interest submitted',
};
